import Vue from "vue";

const registerGlobalComponents = () => {
  // Lazy-loaded components
  Vue.component("PatientProfile", () => import("@/components/PatientProfile"));
};

export default registerGlobalComponents;